import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WebNavigationService} from "../navigation/navigation.service";
import {FormBuilder, NgForm, Validators} from "@angular/forms";
import {PasswordValidation} from "../../core/validators/password-validation";
import {HttpClient} from "@angular/common/http";
import {UrlsResources} from "../../core/urls-resources";
import {AuthService} from "../../core/auth/auth.service";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {

  changePasswordForm;

  constructor(private webNavigationService: WebNavigationService,
              private formBuilder: FormBuilder,
              private httpClient: HttpClient,
              private urlsResources: UrlsResources,
              private authService: AuthService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.webNavigationService.selectOption('perfil');
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPasword: ['', Validators.required],
      newPasswordConfirm: ['', Validators.required],
    }, {
      validator: PasswordValidation.MatchFieldsFactory('newPasword', 'newPasswordConfirm', 'matchField')
    });
  }

  onSubmit() {
    console.log("PerfilComponent#onSubmit:changePasswordForm", this.changePasswordForm);
    const httpOptions = {
      withCredentials: true
    };
    const boddy = {
      currentPassword: this.changePasswordForm.get('oldPassword').value,
      newPassword: this.changePasswordForm.get('newPasword').value,
      userId: this.authService.getUserInfo().username
    };
    console.log("PerfilComponent#onSubmit:boddy", boddy);
    this.httpClient.post(this.urlsResources.getCahngePasswordUrl(), boddy, httpOptions).subscribe((response) => {
      console.log("PerfilComponent#onSubmit:getCahngePasswordUrl:response", response);
      this.changePasswordForm.reset();
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'La contraseña se cambio correctamente'
      });
    }, (err) => {
      console.log("PerfilComponent#onSubmit:getCahngePasswordUrl:err", err);
      this.changePasswordForm.reset();
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: 'Contraseña incorrecta'
      });
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/perfil/perfil.component.ts